import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "./axios";
import { reArangeFilters } from "utils";

interface UploadBlogArgs {
  formData: FormData;
  onProgress?: (percent: number) => void;
}

interface UpdateBlogPayload {
  blogId: number;
  data: any;
  onProgress?: (percent: number) => void;
}

export const saveBlog = createAsyncThunk(
  "blogs/saveBlog",
  async ({ formData, onProgress }: UploadBlogArgs, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/marketplace/blog-posts`, formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total ?? 1)
          );
          if (onProgress) {
            onProgress(Math.min(percent, 90)); 
          }
        },
      });

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getBlogs = createAsyncThunk('all/marketplace/blog-posts', async (payload:any) => {
  try {
    const query = reArangeFilters(payload);
    const response = await axios.get(`/marketplace/blog-posts${query}`) 
    return response.data;
  } catch (error: any) {
    console.log(error?.message,'error', error);
  }
});

export const updateBlog = createAsyncThunk(
  "blogs/updateBlog",
  async ({ blogId, data, onProgress }: UpdateBlogPayload, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`/marketplace/blog-posts/${blogId}`, data, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / (progressEvent.total ?? 1)
          );
          if (onProgress) {
            onProgress(Math.min(percent, 90));
          }
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteBlog = createAsyncThunk('delete/marketplace/blog-posts', async (id: number | null, thunkAPI) => {
  try {
    const response = await axios.delete(`/marketplace/blog-posts/${id}`)
    return response.data;
  } catch (error: any) {
    console.log(error?.message, 'error', error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});